import { render } from "./NotificationMessage.vue?vue&type=template&id=6e914d88&scoped=true&ts=true"
import script from "./NotificationMessage.vue?vue&type=script&lang=ts"
export * from "./NotificationMessage.vue?vue&type=script&lang=ts"

import "./NotificationMessage.vue?vue&type=style&index=0&id=6e914d88&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e914d88"]])

export default __exports__